import { takeEvery, put } from 'redux-saga/effects';
import axios from 'axios';
import setCookie from 'utils/helpers/setCookie';
import getCookie from 'utils/helpers/getCookie';

function* login({ type, payload }) {
  try {
    const { email, password } = payload;
    const res = yield axios.post(`${process.env.VITE_API_URL}/auth/login`, {
      email,
      password,
    });

    localStorage.setItem('token', res.data.accessToken);

    if (getCookie('exitPromptShown') != 'true') {
      setCookie('exitPromptShown', '');
    }

    if (res.status === 200) {
      yield put({ type: 'AUTH/LOGIN_SUCCESS', payload: res.data.accessToken });

      // Window Datalayer
      try {
        const meRes = yield axios.get(
          `${process.env.VITE_API_URL}/auth/me?timestamp=${+new Date()}`,
          {
            headers: {
              Authorization: res.data.accessToken,
            },
          },
        );
      } catch (err) {
        console.error('Error getting user data');
      }

      // yield put({
      //   type: 'AUTH/FETCH_USER_DATA',
      //   payload: res.data.accessToken,
      // });
    }
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put({ type: 'AUTH/LOGIN_ERROR', payload: 'Invalid Credentials' });
    } else {
      yield put({
        type: 'AUTH/LOGIN_ERROR',
        payload: 'An unknown error occured. Please try again.',
      });
    }
  }
}

function* fetchUserData({ type, payload: token }) {
  // console.log('FETCHING USER DATA...');
  try {
    yield put({ type: 'AUTH/LOGIN_SUCCESS', payload: token });
    const res = yield axios.get(
      `${process.env.VITE_API_URL}/auth/me?timestamp=${+new Date()}`,
      {
        headers: {
          Authorization: token,
        },
      },
    );

    if (res.status === 200) {
      if (!getCookie('accountId')) {
        setCookie('accountId', res.data.accountId);
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'start_pw',
        pw_user_email: res.data.email,
      });

      localStorage.setItem('token', token);

      yield put({ type: 'AUTH/FETCH_USER_DATA_SUCCESS', payload: res.data });

      if (res.data?.crmSettings?.crm == 'Salesforce') {
        try {
          const metaData = yield axios.get(
            `${process.env.VITE_API_URL}/sf-to-ga/metadata`,
          );
          if (metaData.data.success) {
            yield put({
              type: 'AUTH/UPDATE_USER_DATA',
              payload: { sfToGa: metaData.data.data },
            });
          }
        } catch (err) {
          console.log(err);
        }
      } else if (res.data?.crmSettings?.crm == 'Zoho CRM') {
        try {
          const metaData = yield axios.get(
            `${process.env.VITE_API_URL}/zoho-to-ga/metadata`,
          );
          if (metaData.data.success) {
            yield put({
              type: 'AUTH/UPDATE_USER_DATA',
              payload: { crmToGaData: metaData.data.data },
            });
          }
        } catch (err) {
          console.log(err);
        }
      }
    } else if (res.status === 401) {
      yield put({
        type: 'AUTH/FETCH_USER_DATA_ERROR',
        payload: 'Invalid Credentials',
      });
    } else {
      yield put({
        type: 'AUTH/FETCH_USER_DATA_ERROR',
        payload: 'An unknown error occured',
      });
    }
  } catch (err) {
    console.error('fetchUserData error:', err);
    if (
      err.response &&
      (err.response.status === 404 ||
        err.response.status === 500 ||
        err.response.status === 401)
    ) {
      localStorage.removeItem('token');
      yield put({ type: 'AUTH/LOGOUT' });
    } else {
      localStorage.removeItem('token');
      yield put({ type: 'AUTH/LOGOUT' });
    }
  }
}

function* logout() {
  localStorage.removeItem('token');
}

export default function* defaultSaga() {
  yield takeEvery('AUTH/LOGIN', login);
  yield takeEvery('AUTH/FETCH_USER_DATA', fetchUserData);
  yield takeEvery('AUTH/LOGOUT', logout);
}
